import React from 'react';
import { SWRConfig } from 'swr'
import './styles.css';
import Routes from '../../Utils/router';
import { getTokenString } from '../../Utils/helper';

export default function App() {
    const header = { headers: { Authorization: getTokenString() } }
    const fetcher = (url) => fetch(url, header).then((res) => res.json());

    return (
        <SWRConfig value={{ fetcher }}>
            <Routes/>
        </SWRConfig>
    );
}
